import React from 'react';
import { useLocation } from 'react-router';
import { Index, Hits, Configure } from 'react-instantsearch-hooks-web';

import OrderDetail from './OrderDetail';

export default function OrderIndex() {
  const location = useLocation();
  const orderKey = location.pathname.split('/')[2];

  return (
    <div>
      <Index indexName="orders">
        <Configure query={orderKey} />
        <Hits hitComponent={OrderDetail} />
      </Index>
    </div>
  );
}
